import { GROUPES_NAV } from './Navigation'
import type { Onglet } from './App'

/**
 * La barre latérale du Dispatch, **à l'identique de la console d'origine**.
 *
 * Chaque classe compte, et c'est la leçon du portage raté : `.logo`, `.bt`,
 * `.side-group`, `.side-group-label`, `.nav-item`, `.nl`, `.side-toggle` sont
 * toutes stylées dans la feuille reprise telle quelle. Une réécriture « qui
 * fait la même chose » avec d'autres noms produit un CSS intact auquel plus
 * rien ne s'accroche — soit, à l'écran, une régression pure.
 */
const Logo = () => (
  <svg className="logo" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="11" fill="var(--or)" />
    <g className="bell-g">
      <circle cx="20" cy="12.4" r="2.1" fill="var(--encre)" />
      <path d="M9.4 26.8a10.6 10.6 0 0121.2 0z" fill="var(--encre)" />
      <path d="M7 30.2h26" stroke="var(--encre)" strokeWidth="2.4" strokeLinecap="round" />
      <path
        d="M14.2 21.8c1.1-2.7 3.2-4.7 5.8-5.4"
        stroke="var(--or-p)"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity=".7"
      />
    </g>
  </svg>
)

export function BarreLaterale({
  actif,
  autorise,
  nbActives,
  replie,
  surChangement,
  surReplier,
  surMotDePasse,
  surDeconnexion,
}: {
  actif: Onglet
  autorise: (o: Onglet) => boolean
  nbActives: number
  replie: boolean
  surChangement: (o: Onglet) => void
  surReplier: () => void
  surMotDePasse: () => void
  surDeconnexion: () => void
}) {
  return (
    <aside className={`sidebar${replie ? ' collapsed' : ''}`}>
      <div className="side-brand">
        <Logo />
        <span className="bt">
          Swift<span>Eats</span>
        </span>
      </div>

      <nav className="side-nav">
        {GROUPES_NAV.map((groupe) => {
          const visibles = groupe.items.filter((i) => autorise(i.tab as Onglet))
          // Un groupe dont toutes les entrées sont masquées ne doit pas laisser
          // son intitulé orphelin au-dessus du vide.
          if (visibles.length === 0) return null
          return (
            <div className="side-group" key={groupe.label}>
              <div className="side-group-label">{groupe.label}</div>
              {visibles.map((item) => (
                <button
                  key={item.tab}
                  className={`nav-item${actif === item.tab ? ' active' : ''}`}
                  title={item.nom}
                  onClick={() => surChangement(item.tab as Onglet)}
                >
                  {item.icone}
                  <span className="nl">{item.nom}</span>
                  {item.tab === 'live' && nbActives > 0 && (
                    <span className="chip-n">{nbActives}</span>
                  )}
                </button>
              ))}
            </div>
          )
        })}
      </nav>

      <div className="side-foot">
        <button className="nav-item" onClick={surMotDePasse} title="Changer mon mot de passe">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span className="nl">Mot de passe</span>
        </button>
        <button className="nav-item" onClick={surDeconnexion} title="Déconnexion">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          <span className="nl">Déconnexion</span>
        </button>
        <button className="side-toggle" onClick={surReplier} title="Réduire / agrandir">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <span className="nl">Réduire</span>
        </button>
      </div>
    </aside>
  )
}
